import React from "react";
import {connect} from "react-redux";
import { Switch, Route } from "react-router-dom";


import Form from 'views/IbAccountRules/Form'
import List from 'views/IbAccountRules/List'


class IbAccountRules extends React.Component {
  render() {
    const {match}=this.props;
    return (

          <Switch>
            <Route exact path={`${match.path}/add`} component={Form}/>
            <Route exact path={`${match.path}/:id`} component={Form}/>
            <Route component={List}/>
          </Switch>

    );
  }
}
const state=(state)=>({})
const dispatch=(dispatch)=>({})
export default connect(state,dispatch)(IbAccountRules);



// WEBPACK FOOTER //
// ./src/views/IbAccountRules/IbAccountRules.jsx